// Set when the server has deleted the account and this device is finishing up (sign out, optionally remove the offline copy).
// The next page lifecycle reads it to show a calm "deleted" screen instead of the generic closed-workspace one, and to carry on
// into the guest workspace by itself. It expires, so a missed clean-up never leaves the message behind for long.
const KEY = 'minimany:account-deleted:v1'
const EXPIRES_MS = 60 * 60 * 1000

export function markAccountDeleted(now = Date.now()): void {
  try { localStorage.setItem(KEY, String(now)) } catch { /* The generic screen still works. */ }
}

export function accountDeletedPending(now = Date.now()): boolean {
  try {
    const stored = Number(localStorage.getItem(KEY))
    return Number.isFinite(stored) && stored > 0 && now - stored >= 0 && now - stored < EXPIRES_MS
  } catch { return false }
}

export function clearAccountDeleted(): void {
  try { localStorage.removeItem(KEY) } catch { /* Expires by itself. */ }
}
